import React from 'react';
import './about.css';
import { AnimatePresence, motion } from 'framer-motion';
import strategy from '../../assets/images/about/strategy.jpg';
import creation from '../../assets/images/about/creation.jpg';
import production from '../../assets/images/about/production.mp4';
import { Helmet } from 'react-helmet';

const AboutUs = () => {

  const gallery = [
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2FDSC09448%201.png?alt=media&token=5da48869-19ae-4c2b-acfa-433efe942ca4',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2FDSC04080%201.png?alt=media&token=a9fa44ea-0180-4c42-806d-4c8943da2a29',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2FDSC04010%202.png?alt=media&token=b7fddeef-a341-4801-a976-68ab6387bed4',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2FScreenshot%202024-01-24%20at%2016.35%201.png?alt=media&token=f47ce411-53fe-489d-b5eb-2a799baee994',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2FDSC07265%201.png?alt=media&token=b52aaf36-17e5-4151-9085-a056bc30694b',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2FDSC03801%201.png?alt=media&token=23b01f9e-6515-4869-b120-9696236733eb',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2Fimage-1.png?alt=media&token=c543b175-43c5-484b-b4f9-25539b7b96df',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2F_MG_5912%201.png?alt=media&token=60b186af-9185-40a1-bb39-e4e6ddeb51ca',
    'https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/gallery_about%2Fimage.png?alt=media&token=22a92141-103d-40a6-9b39-4960e841f3b8',
  ]

  return (
    <>
      <Helmet>
        <title>WEAREBIAM | ABOUT US</title>
        <meta name="description" content="WE ARE A creative PRODUCTION powerhouse that pushes boundaries, inspires, and empowers a generation of creators Through innovative thinking. WE transforms cultural and creative values into powerful business strategies." />

        {/* Open Graph */}
        <meta property="og:title" content="WEAREBIAM | ABOUT US" />
        <meta property="og:description" content="WE ARE A creative PRODUCTION powerhouse that pushes boundaries, inspires, and empowers a generation of creators Through innovative thinking. WE transforms cultural and creative values into powerful business strategies." />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/assets%2Fwebcover_bw.png?alt=media&token=f3686ce5-b347-4f99-8b23-0f52d461675c" />
        <meta property="og:url" content="https://wearebiam.com/about" />
        <meta property="og:type" content="website" />

      </Helmet>
      <div className="flex bg-white items-center justify-center w-full">

        <div className="flex flex-col max-w-[1440px] gap-[30px] w-full min-h-screen bg-white lg:p-[5rem] p-[1.25rem]">

          <div className="flex flex-col">
            <motion.p
              className="text-black lg:text-[82px] text-[38px] ppmori lg:mt-[50px] mt-[100px] leading-none"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              BE MORE, DO MORE.
            </motion.p>

            <motion.p className="text-black lg:text-[16px] text-[12px] ppmori"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              CREATIVE PRODUCTION. CULTURE MANAGEMENT. LOCAL STRATEGY. DRIVING GLOBAL INTERACTIONS
            </motion.p>
          </div>

          {/* 📱 Mobile version */}
          <div className="relative w-screen overflow-hidden block lg:hidden -ml-[1.25rem]">
            <div
              className="animate-scroll-gallery"
              style={{
                width: `calc(${gallery.length * 2} * (104px + 6px))`,
              }}
            >
              {[...gallery, ...gallery].map((img, index) => (
                <div
                  key={`mobile-${index}`}
                  className="inline-block w-[104px] h-[148px] bg-white bg-cover bg-no-repeat bg-center rounded-[10px] mx-[3px]"
                  style={{ backgroundImage: `url(${img})` }}
                />
              ))}
            </div>
          </div>

          {/* 💻 Desktop version - FULL WIDTH FIXED */}
          <div className="w-full overflow-visible hidden lg:block">
            <div className="w-[calc(100vw-1440px)] relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
              <div
                className="animate-scroll-gallery"
                style={{
                  width: `calc(${gallery.length * 2} * (208px + 6px))`,
                }}
              >
                {[...gallery, ...gallery].map((img, index) => (
                  <div
                    key={`desktop-${index}`}
                    className="inline-block w-[208px] h-[296px] bg-white bg-cover bg-no-repeat bg-center rounded-[10px] mx-[3px]"
                    style={{ backgroundImage: `url(${img})` }}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-5 ">
            <p className="lg:w-[650px] ppmori">
              BIAM is a creative production powerhouse that pushes boundaries, inspires action, and empowers a new generation of creators through bold thinking and cultural relevance. We transform creative energy & cultural values into business strategy—bridging culture, innovation, and impact.
            </p>

            <p className="lg:w-[650px] ppmori">
              At our core, BIAM brings together an event production studio, a culture and talent management agency, a branding and marketing unit, and a bunch of creative concepts. Through this ecosystem, we craft immersive phygital experiences that shape local market trends and spark global conversations.
            </p>
          </div>

          <div className="relative mt-[100px] mb-[250px]">
            <div className="flex flex-col sm:flex-row gap-10 lg:gap-[250px] sm:items-start items-center">

              <motion.p
                className="text-[38px] lg:text-[64px] text-center sm:text-left sm:w-[280px] lg:ml-[100px] leading-none text-black font-semibold w-full sticky bg-white sm:bg-transparent py-5  top-[60px] sm:top-[150px] self-start"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                WHY DO <br className='sm:block hidden' />
                WE DO, <br />
                WHAT <br className='sm:block hidden' />
                WE DO
              </motion.p>

              <motion.p
                className="max-w-[500px]"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >

                We grew up in a region where storytelling was everywhere—but rarely structured to create impact or scale. So, we chose to do things differently.
                <br /> <br />
                Every strategy we write, every space we design, every experience we produce is rooted in one mission: to help creators, brands, and communities unlock their full potential.
                <br /> <br />
                We exist to connect the dots between culture, business, and innovation—because when done right, creativity doesn’t just entertain. It elevates, it educates, and it builds legacies.
                <br /> <br />
                Most of all, we’re building this for a generation that refuses to be silenced. A generation that aspires to express themselves boldly—and is deeply committed to shaping the stories, images, and narratives that define us.
                <br /> <br />
                Creativity is our tool. Transformation is our goal.
                <br /> <br /><br />
                <div className="flex flex-col">
                  <p className='text-[18px] font-bold uppercase'>PATRICK BANOU</p>
                  <p className='text-[13px]'>➔ FOUNDER</p>
                </div>

              </motion.p>

            </div>
          </div>

          <div className="relative mt-[100px] mb-[250px]">
            <div className="flex flex-col sm:flex-row gap-10 lg:gap-[250px] sm:items-start items-center">

              {/* LEFT SECTION — sticky only on large screens */}
              <p className="text-[38px] lg:text-[64px] text-center sm:text-left sm:w-[280px] lg:ml-[100px] leading-none text-black font-semibold w-full sticky bg-white sm:bg-transparent py-5  top-[60px] sm:top-[150px] self-start">
                WHAT <br className='sm:block hidden' />
                WE <br className='sm:block hidden' />
                LOVE <br className='sm:block hidden' />
                DOING
              </p>

              {/* RIGHT SECTION — scrollable and stacked */}
              <motion.div
                className="flex flex-col sm:gap-[100px] gap-10"
                initial="hidden"
                animate="visible"
                variants={{
                  visible: {
                    transition: {
                      staggerChildren: 0.15
                    }
                  }
                }}
              >
                <AnimatePresence>

                  {/* === START OF ONE BLOCK === */}
                  <motion.div
                    variants={{
                      hidden: { opacity: 0, scale: 0.95 },
                      visible: { opacity: 1, scale: 1 }
                    }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.5 }}
                  >
                    {/* On répète le titre à gauche en mobile uniquement */}

                    <div className="flex flex-col gap-[35px] max-w-[400px]">
                      <div
                        className="flex w-full aspect-[4/5] bg-darkgrey bg-cover bg-no-repeat bg-center"
                        style={{ backgroundImage: `url(${strategy})` }}
                      />

                      <div className="flex items-start lg:gap-[30px] gap-5 w-full text-black ppmori">
                        <p className="text-[30px]">01</p>
                        <div className="flex flex-col gap-2.5">
                          <p className="text-[30px]">STRATEGY</p>
                          <p className="lg:text-[16px] text-[12px]">We craft strategies that move culture and deliver results.</p>
                          <p className="lg:text-[20px] text-[16px]">
                            BRAND STRATEGY. <br />
                            MARKETING PLANS.<br />
                            CONTENT & SOCIAL MEDIA<br />
                            STRATEGY.<br />
                            INFLUENCE MARKETING.
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                  {/* === END OF BLOCK === */}

                  {/* Les autres blocs ici → CREATION, PRODUCTION, etc. */}

                </AnimatePresence>

                <AnimatePresence>

                  <motion.div
                    variants={{
                      hidden: { opacity: 0, scale: 0.95 },
                      visible: { opacity: 1, scale: 1 }
                    }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div className="flex flex-col gap-[35px] max-w-[400px]">
                      <div
                        className="flex w-full aspect-[4/5] bg-darkgrey bg-cover bg-no-repeat bg-center"
                        style={{ backgroundImage: `url(${creation})` }}
                      />

                      <div className="flex items-start lg:gap-[30px] gap-5 w-full text-black ppmori">

                        <p className="text-[30px]">02</p>

                        <div className="flex flex-col gap-2.5">
                          <p className="text-[30px]">CREATION</p>
                          <p className="lg:text-[16px] text-[12px]">We bring ideas to life with bold visuals and immersive experiences.</p>
                          <p className="lg:text-[20px] text-[16px]">
                            BRAND ACTIVATION.<br />
                            VISUAL DESIGN.<br />
                            BRANDING<br />
                            SCENOGRAPHY.<br />
                          </p>
                        </div>

                      </div>
                    </div>
                  </motion.div>

                </AnimatePresence>

                <AnimatePresence>

                  <motion.div
                    variants={{
                      hidden: { opacity: 0, scale: 0.95 },
                      visible: { opacity: 1, scale: 1 }
                    }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div className="flex flex-col gap-[35px] max-w-[400px]">

                      <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className={"flex w-full aspect-[4/5] bg-darkgrey bg-cover bg-no-repeat bg-center"}
                      >
                        <source src={production} type="video/mp4" />

                      </video>

                      <div className="flex items-start lg:gap-[30px] gap-5 w-full text-black ppmori">

                        <p className="text-[30px]">03</p>

                        <div className="flex flex-col gap-2.5">
                          <p className="text-[30px]">PRODUCTION</p>
                          <p className="lg:text-[16px] text-[12px]">From concept to execution, we produce powerful stories that connect.</p>
                          <p className="lg:text-[20px] text-[16px]">
                            EVENTS.<br />
                            CAMPAIGNS.<br />
                            CONTENT.<br />
                            DIGITAL PRODUCTS.<br />
                          </p>
                        </div>

                      </div>
                    </div>
                  </motion.div>

                </AnimatePresence>

              </motion.div>
            </div>
          </div>

        </div>

      </div>
    </>

  );
};

export default AboutUs;